import React from "react";
import { themes } from "../../utils/themes";
import ThemeSwatch from "./ThemeSwatch";

const ThemePicker = ({ theme, onChoose, t }) => (
  <div>
    <label className="block text-xs font-semibold uppercase tracking-wide text-slate-400 mb-3">
      {t("Theme")}
    </label>
    <div className="theme-picker grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 gap-3 max-h-72 overflow-y-auto bg-slate-50 border border-slate-200 rounded-xl p-3">
      {themes.map((themeItem) => (
        <ThemeSwatch
          key={themeItem.name}
          themeItem={themeItem}
          selected={theme === themeItem.name}
          onSelect={() => onChoose(themeItem.name)}
        />
      ))}
    </div>
  </div>
);

export default ThemePicker;
